<template>
  <div class="layout">
    <layout-head />
    <layout-breadcrumb
      v-if="!$route.meta.hideBreadcrumb && $route.name !== 'home'"
    />
    <layout-main />
    <layout-footer />
  </div>
</template>

<script>
import LayoutHead from "@/layout/components/LayoutHead/index.vue";
import LayoutFooter from "@/layout/components/LayoutFooter/index.vue";
import LayoutMain from "@/layout/components/LayoutMain.vue";
import LayoutBreadcrumb from "@/layout/components/LayoutBreadcrumb.vue";
export default {
  name: "Layout",
  components: { LayoutBreadcrumb, LayoutHead, LayoutFooter, LayoutMain },

  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.layout {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
}
</style>
